import Vue from 'vue'
window.Vue = Vue;
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store'
import Tooltip from 'vue-directive-tooltip';
Vue.use(Tooltip);
// const Jquery = require('jquery');
// window.$ = Jquery;
import VueSweetalert2 from 'vue-sweetalert2';
import 'sweetalert2/dist/sweetalert2.min.css';
Vue.use(VueSweetalert2);

import plugins from './plugins/index';
plugins.install(Vue);

Vue.config.productionTip = false;

Vue.prototype.$helpers.setData().then(() => {
    const vm = new Vue({
        router,
        store,
        render: h => h(App)
    }).$mount('#dashboard-app')

    Vue.prototype.$vm = vm;

    setTimeout(() => {
        $('body').removeClass('overflow-hidden');

        $('.page-preloader').hide();
    }, 2000);
});